export const logClicksConstants = {
    LOG_CLICKS_LOADING: 'LOG_CLICKS_LOADING',
    LOG_CLICKS_LOADING_ERROR: 'LOG_CLICKS_LOADING_ERROR',
    LOG_CLICKS_SET_IS_LOADING: 'LOG_CLICKS_SET_IS_LOADING',
    LOG_CLICKS_UPDATE_ORDER_BY: 'LOG_CLICKS_UPDATE_ORDER_BY',
    LOG_CLICKS_UPDATE_SORT_BY: 'LOG_CLICKS_UPDATE_SORT_BY',
    LOG_CLICKS_UPDATE_CLICK_ID: 'LOG_CLICKS_UPDATE_CLICK_ID',
    LOG_CLICKS_UPDATE_SORT_COLUMNS: 'LOG_CLICKS_UPDATE_SORT_COLUMNS',
    LOG_CLICKS_INFINITY_SCROLL: 'LOG_CLICKS_INFINITY_SCROLL',
    LOG_CLICKS_RERENDER: 'LOG_CLICKS_RERENDER'
};
